/**
 * The regular expression pattern to validate emails.
 * Taken from: https://stackoverflow.com/a/742588/322984
 * NB. Synchronize with server side.
 */
export const EmailRegex = /^[^@\s]+@[^@\s]+\.[^@\s]+$/i;